import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Popover } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';
import NotificationsPanel from './NotificationsPanel/index.tsx';
import NotificationButton from './NotificationButton/index.tsx';
import { useWindowSize } from '../../hooks/index.js';
import { useDecision } from '@walmart-dataventures/feature-flag-sdk-react';
import {
  API_STATUS_CODE,
  NOTIFICATIONS_FEATURE_KEY,
  NOTIFICATIONS_POLLING_INTERVAL
} from '../../constants/common.js';
import { getNotificationsCount } from '../../api/notifications.ts';
import { logger } from '../../utils/logger.js';
import { useAppDispatch } from '../../redux/hooks.ts';
import { notificationsActions } from '../../redux/slices/notifications.ts';

const Notifications = () => {
  const [decision] = useDecision(NOTIFICATIONS_FEATURE_KEY);
  const dispatch = useAppDispatch();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const { width } = useWindowSize();
  const history = useHistory();
  const location = useLocation();
  const [showNotifications, setShowNotifications] = useState(false);
  const buttonRef = useRef(null);

  const openNotificationPanel = () => {
    logger.clickStream('notification_bell_click', {
      panelistId: localStorage.getItem('panelistId') || ''
    });
    setShowNotifications(true);
  };

  const closeNotificationPanel = () => {
    logger.clickStream('notification_panel_close_click', {
      panelistId: localStorage.getItem('panelistId') || ''
    });
    setShowNotifications(false);
  };

  const getCount = () => {
    getNotificationsCount().then((res) => {
      if (res.status === API_STATUS_CODE.SUCCESS) {
        dispatch(notificationsActions.setCount(res.data.count));
      } else {
        logger.error('Error getting notifications count', (res as any).error);
      }
    });
  };

  useEffect(() => {
    if (!decision.enabled) return;

    getCount();
    intervalRef.current = setInterval(getCount, NOTIFICATIONS_POLLING_INTERVAL);

    return () => {
      if (!intervalRef.current) return;
      clearInterval(intervalRef.current);
    };
  }, [decision.enabled]);

  const handleMobileNotificationButtonClick = () => {
    logger.clickStream('notification_mobile_bell_click', {
      panelistId: localStorage.getItem('panelistId') || ''
    });
    history.push('/notifications', { from: location.pathname });
  };
  if (typeof width != 'number' || !decision.enabled) return null;

  return width <= 600 ? (
    <NotificationButton onClick={handleMobileNotificationButtonClick} />
  ) : (
    <Popover
      content={<NotificationsPanel onClose={closeNotificationPanel} />}
      onClose={closeNotificationPanel}
      triggerRef={buttonRef}
      isOpen={showNotifications}
      position="bottomLeft"
      basePopoverProps={{ className: styles.notificationsPopover }}
    >
      <NotificationButton ref={buttonRef} onClick={openNotificationPanel} />
    </Popover>
  );
};

export default Notifications;
